export const ADMIN_77_STORAGE_PREFIX = '@77sol-admin:'
